export default {
    apiGetMasterCategory(data) {
        return this.request(this.api().getMasterCategory, data)
            .exec()
            .log()
            .mapresults((res) => res)
            .get();
    },
    apiGetMasterCategoryById(data) {
        return this.request(this.api().getMasterCategoryById, data)
            .urltransform(data)
            .exec()
            .mapresults((res) => res)
            .get();
    },
    apiCreateMasterCategory(data) {
        return this.request(this.api().createMasterCategory, data)
            .urltransform(data)
            .exec()
            .mapresults((res) => res)
            .get();
    },
    apiUpdateMasterCategory(data, urldata = {}) {
        return this.request(this.api().updateMasterCategory, data)
            .urltransform(urldata)
            .exec()
            .mapresults((res) => res)
            .get();
    },
    apiDeleteMasterCategory(data, urldata = {}) {
        return this.request(this.api().deleteMasterCategory, data)
            .urltransform(urldata)
            .exec()
            .mapresults((res) => res)
            .get();
    },
    apiGetFileMetaData(data) {
        return this.request(this.api().getFileMetaData, data)
            .urltransform(data)
            .exec()
            .mapresults((res) => res)
            .get();
    }
};
